import { render, staticRenderFns } from "./GenericTableLocationsModal.vue?vue&type=template&id=6fc0b8e7"
import script from "./GenericTableLocationsModal.vue?vue&type=script&lang=ts"
export * from "./GenericTableLocationsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports